export const isObject = (value: any) => value !== null && typeof value === 'object';

export type ObjectByKey<T> = { [key: string]: T | undefined };
